import mastercard from "../../assets/svg-icons/footer/mastercard.svg";
import visa from "../../assets/svg-icons/footer/visa_icon.svg";
import stcPay from "../../assets/svg-icons/footer/stc-pay.png";
import applePay from "../../assets/svg-icons/footer/apple-pay.png";
import payy from "../../assets/svg-icons/footer/payy.png";

const payData = [
    {
        id: "p_1",
        title: "mastercard",
        link: "#",
        icon: mastercard
    },
    {
        id: "p_2",
        title: "visa",
        link: "#",
        icon: visa
    },
    {
        id: "p_3",
        title: "stcPay",
        link: "#",
        icon: stcPay
    },
    {
        id: "p_4",
        title: "applePay",
        link: "#",
        icon: applePay
    },
    {
        id: "p_5",
        title: "payy",
        link: "#",
        icon: payy
    }
];

export default payData;
